import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NgbCollapseModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NotifierModule } from 'angular-notifier';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ROUTE_INFO } from '../../config/environment.config.token';
import { MainLayoutComponent } from './app-layout/main-layout/main-layout.component';
import { HeaderComponent } from './header/header.component';
import { NotificationBarComponent } from './header/notification-bar/notification-bar.component';
import { PageLoaderComponent } from './page-loader/page-loader.component';
import { RightSidebarComponent } from './right-sidebar/right-sidebar.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouteInfo } from './sidebar/sidebar.metadata';

@NgModule({
  declarations: [
    SidebarComponent,
    HeaderComponent,
    RightSidebarComponent,
    MainLayoutComponent,
    PageLoaderComponent,
    NotificationBarComponent
  ],
  imports: [
    CommonModule,
    PerfectScrollbarModule,
    NgbModule,
    NgbCollapseModule,
    MatIconModule,
    MatButtonModule,
    RouterModule,
    TranslateModule.forChild(),
    NgxSpinnerModule,
    NotifierModule
  ],
  exports: [PageLoaderComponent],
})
export class MedDataLayoutModule {

  static forRoot(
    routeInfo: RouteInfo[]
  ): ModuleWithProviders<MedDataLayoutModule> {
    return {
      ngModule: MedDataLayoutModule,
      providers: [
        {
          provide: ROUTE_INFO,
          useValue: routeInfo,
          multi: false,
        },
      ],
    };
  }
}
